import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DOMParser } from '@atlaskit/editor-prosemirror/model';
import { MarkdownSerializer, marks, nodes } from './serializer';
import { transformHtml } from './util';
export var BitbucketTransformer = /*#__PURE__*/function () {
  function BitbucketTransformer(schema) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, BitbucketTransformer);
    _defineProperty(this, "serializer", new MarkdownSerializer(nodes, marks));
    this.schema = schema;
    this.options = options;
  }
  _createClass(BitbucketTransformer, [{
    key: "encode",
    value: function encode(node) {
      return this.serializer.serialize(node);
    }
  }, {
    key: "parse",
    value: function parse(html) {
      var dom = this.buildDOMTree(html);
      return DOMParser.fromSchema(this.schema).parse(dom);
    }
  }, {
    key: "buildDOMTree",
    value: function buildDOMTree(html) {
      return transformHtml(html, this.options);
    }
  }]);
  return BitbucketTransformer;
}();